export default __webpack_public_path__ + "static/media/ME-AWS.d9097246.png";